import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_ERROR } from '../constants/ActionTypes';
import setUpdateUserSuccess from './setUpdateUserSuccess';
import { push } from 'connected-react-router';

function updateUserPasswordRequest() {
    return {
        type: UPDATE_USER_REQUEST,
    };
}

function updateUserPasswordSuccess(user) {
    return {
        type: UPDATE_USER_SUCCESS,
        body: user,
    };
}

function updateUserPasswordError(error) {
    return {
        type: UPDATE_USER_ERROR,
        error,
    };
}

export default function updateUserPassword(payload, requestDelay) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, router } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const userPayload = { ...payload, logonPasswordVerify: payload.logonPassword };

        const request = Person.userUpdate({
            baseUrl,
            brandId,
            country,
            user: userPayload,
            uberToken,
            clientId,
            clientSecret,
            options: locale.langISO ? { locale: locale.langISO } : undefined,
        });

        const redirect = `/${locale.id}/account/details`;

        dispatch(updateUserPasswordRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), requestDelay || clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response
                        .json()
                        .then(() => dispatch(updateUserPasswordSuccess(payload)))
                        .then(() => dispatch(push(redirect)))
                        .then(() => dispatch(setUpdateUserSuccess('changePassword')));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(updateUserPasswordError(error));
                throw error;
            });
    };
}
